import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Styles } from './style';
import { PropertySearchForm } from '../PropertyOrder/data';
import AuthenticatedLayout from '@screens/Authenticated/Layout/Layout';

const OrderPropertyDetailScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const propertyOrder = PropertySearchForm[Number(id)];

  if (!propertyOrder) {
    return <h1>Encomenda não encontrada</h1>;
  }

  return (
    <AuthenticatedLayout>
      <h1>ENCOMENDA DE IMÓVEL</h1>
      <Styles.RectangleBar />
      <Styles.DetailContainer>
        <h2>Informações do Cliente</h2>
        <p>
          <strong>Nome:</strong> {propertyOrder.clientInfo.name}
        </p>
        <p>
          <strong>Email:</strong> {propertyOrder.clientInfo.email}
        </p>
        {propertyOrder.clientInfo.phone && (
          <p>
            <strong>Telefone:</strong> {propertyOrder.clientInfo.phone}
          </p>
        )}
        {propertyOrder.clientInfo.neighborhood && (
          <p>
            <strong>Bairro de interesse:</strong>
            {propertyOrder.clientInfo.neighborhood}
          </p>
        )}

        <h2>Detalhes da Encomenda</h2>
        <p>
          <strong>Tipo de operação:</strong> {propertyOrder.operationType}
        </p>
        <p>
          <strong>Tipo de imóvel:</strong> {propertyOrder.propertyType}
        </p>
        <p>
          <strong>Cidade desejada:</strong> {propertyOrder.desiredCity}
        </p>
        <p>
          <strong>Requisitos específicos:</strong> {propertyOrder.details}
        </p>
      </Styles.DetailContainer>

      <Styles.ButtonContainer>
        <Styles.BackButton onClick={() => navigate(-1)}>
          Voltar
        </Styles.BackButton>
      </Styles.ButtonContainer>
    </AuthenticatedLayout>
  );
};

export default OrderPropertyDetailScreen;
